// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "script/chunks/chunk." + (chunkId === 34 ? "braintree-web-drop-in" : chunkId) + "." + {"34":"9ae9802f80","70":"ed7f43e7ae"}[chunkId] + ".js";
};